// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1tehe","consentsList":"PatientConsents_consentsList__2Rb-M","consentsListEmpty":"PatientConsents_consentsListEmpty__oAM2L"};